<template>
  <h1>Assemble Orders</h1>
  <div id="page-assemble content-section">

    <div class="assemble-sections" id="assemblyWidget">

      <!-- NEW TASK: Step 1-> Identify the Order -->
      <div class="text-left order-confirm">
        <FormKit
            type="form"
            :actions="false"
            form-class="assemble-form"
        >
          <div class="assemble-section col-12">1. Identify the Order</div>
          <div class="clearfix"></div>
          <div class="row mt-3">
            <div class="col-md-10" >
              <div v-if="!check_qrcode">
                Scan a Service Ticket to identify an Order.
                <barcode-scanner
                    :class="!order_error ? 'success' : 'error'"
                    barcodeId="qrcode"
                    barcodeAction="assembly: identify order"
                    v-model="qrcode"
                    @change="recordBarcode($event.target.value, $event.target.getAttribute('action'))"
                    :key="barcodeScannerKey"
                >
                </barcode-scanner>
                <span v-if="order_error" class="fw-bold text-danger">{{order_error}}</span>
              </div>
              <div v-else>
                <div v-if="!order_error">
                  <div v-if="!qrcode_reset">
                    Order <span class="large-text">{{order.orderid}}</span> for
                    <span class="large-text">{{customer.firstname}} {{customer.surname}}</span><br/>

                    <span class="datedue">
                      Due <span class="large-text">{{formatDateDayShort(order.datedue)}}</span>
                      ({{formatDateEN(order.datedue)}})
                      <span class="blue-bag" v-if="getBlueBagNotice()" :class="getBlueBagNoticeClass()" >{{getBlueBagNotice()}}</span>
                    </span>
                    <div class="mt-3 row" v-if="isDueUnpaid()">
                      <h3><span class=" badge due-unpaid">Order is Unpaid</span></h3>
                    </div>

                     <!-- customer sweets notice -->
                    <div class="mt-3 row" v-if="getSweetsNotice()">
                      <div class="col-12">
                        <span class="badge customer-welcome-card">{{ getSweetsNotice() }}</span>
                      </div>
                    </div>

                    <!-- customer badges (tags and label printing settings) -->
                    <div class="mt-3 row">
                      <div class="col-3" v-for="order_state in order_states">
                        <h3><span class=" badge customer-state " :class="order_state.theme">{{ order_state.title }}</span></h3>
                      </div>

                    </div>
                  </div>
                  <div v-else>
                    <div>
                      <div><label>Order number:</label> {{order.orderid}}</div>
                      <div><label>Customer:</label> {{customer.firstname}} {{customer.surname}}</div>
                      <div><label>Data Due:</label> {{formatDateEN(order.datedue)}}</div>
                    </div>
                    <div class="clearfix"></div>
                    <div>

                      <FormKit
                          type="button"
                          label="Confirm Order"
                          input-class="$reset btn btn-primary btn-sm"
                          @click="confirmOrder"
                          outer-class="float-left mr-4"
                      />
                      <FormKit
                          type="button"
                          label="View Order"
                          input-class="$reset btn btn-primary btn-sm"
                          @click="viewOrder"
                          outer-class="float-left mr-4"
                      />
                      <FormKit
                          type="button"
                          label="Clear Order"
                          input-class="$reset btn btn-primary btn-sm"
                          @click="clearOrder"
                          outer-class="float-left mr-4"
                      />
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="alert alert-danger">{{order_error}}</div>
                </div>
              </div>
            </div>

            <div  class="col-md-2" v-if="order_changed && !qrcode_reset">
              <FormKit
                  type="button"
                  label="Change/Cancel"
                  input-class="$reset btn btn-secondary btn-sm"
                  @click="resetBarcode"
              />
            </div>
          </div>
        </FormKit>
      </div>

      <div class="clearfix"></div>

      <!-- NEW TASK: Step 2 -> Check the Order Notes -->
      <div class=" mt-3 text-left" >
        <div class="assemble-section col-12" :class="!check_notes_error ? 'disabled' : ''">2. Check Assembly Notes</div>
        <div v-if="!check_notes_error">
          Scan an Order to check for notes
        </div>
        <div v-else>
          <div v-if="notes_message">
            <div class="mt-3 row">
              <div class="col-9" v-for="order_note in notes_message">
                <span class="btn btn-notes" >{{ order_note.ordernote }}</span>
              </div>

              <div class="col-md-3 text-left" v-if="notes_barcode_show">
                <barcode-scanner
                    :class="!notes_barcode ? 'full-width success' : 'full-width error'"
                    barcodeId="notes_barcode"
                    barcodeAction="assembly: confirm assembly notes"
                    v-model="notes_barcode"
                    @change="recordBarcode($event.target.value, $event.target.getAttribute('action'))"
                    :key="barcodeScannerKey"
                >
                </barcode-scanner>
              </div>
            </div>

          </div>
          <div v-else>
            {{notes_error}}
          </div>
        </div>
      </div>

      <!-- NEW TASK: Step 3 ->  Scan in the service tickets and confirm items -->
      <div class="clearfix"></div>
      <div class=" mt-3 text-left " >
        <div v-if="show_step3_link" class="assemble-section col-12" :class="!check_tickets_status && !check_assembly_status ? 'disabled' : ''"><a @click="returnToStep3()" class="selected btn btn-success">3. Assemble Tickets</a></div>
        <div v-if="!show_step3_link" class="assemble-section col-12" :class="!check_tickets_status && !check_assembly_status ? 'disabled' : ''">3. Assemble Tickets</div>
        <div v-if="check_assembly_status">
          Order has {{tickets_services.length}} Service Ticket for Assembly
        </div>
        <div v-else-if="!check_tickets_status ">
          Choose an Order to get Service Ticket information
        </div>
        <div v-else>
          <div class="mt-3 row">
            <div class="col-9 ">
              <div>Order has {{tickets_services.length}} Service Ticket for Assembly</div>

              <div class="mt-2">Scan a Ticket to start assembling.</div>
              <div class="assembly-serviceticket">

                <h4>Service Ticket </h4>
                <p v-if="!currentTicket">No Tickets to show</p>
                <p class="assembly-serviceticket-services"  v-if="currentTicket">
                  {{currentTicket.services.join(', ') || 'Unknown Service'}}
                  <span style="float: right;">This ticket contains {{currentTicket.orderitems.length}} item.</span>
                </p>
                <p class="assembly-serviceticket-services" v-if="currentTicket"></p>
                <table  class="assembly-serviceticket-items" v-if="currentTicket">
                  <tbody >
                  <tr  class="header">
                    <th >
                      <!--<lr-check-box  _nghost-c10="">
                        <a _ngcontent-c10="" class="checkbox-anchor">
                          <span _ngcontent-c10="" class="checkbox-inner far fa-circle" style="color: lightgray;"></span>
                        </a>
                      </lr-check-box>-->
                    </th>
                    <th >Item ID</th>
                    <th >Garment Type</th>
                    <th >Garment</th>
                    <th >Status</th>
                  </tr>
                  <!---->
                  <template  v-for="orderItem in currentTicket.orderitems">
                    <tr :class="getOrderItemClass(orderItem, currentTicket)"  >
                      <td >
                        <!-- <span  class="fas fa-check-circle"></span>-->
                        <!-- <span  class="fas fa-exclamation-circle"></span>-->
                        <span  :class="getOrderItemIcon(orderItem, currentTicket)" ></span>
                      </td>
                      <td  class="strike">{{orderItem.orderitemid}}</td>
                      <td  class="strike">{{orderItem.garmenttype}}</td>
                      <td >
                        <a v-if="orderItem.garment_id" target="_blank" :href="baseEPOSPath+'/index.php?page=garment&mode=editor&garment='+orderItem.garment_id+'&order='+order.orderid+''"> View Garment </a>
                      </td>
                      <td >{{getOrderItemStatus(orderItem)}} <span v-if="getOrderItemStatus(orderItem) == 'assembled'">({{formatFullDateEN(orderItem.itemstatustime)}})</span></td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-3 assembly-sidebar">
              <FormKit
                  type="form"
                  @submit.prevent="preventSubmit"
                  :actions="false"
                  form-class="assemble-form"
              >
                <div v-if="check_ticket_barcode">
                  <barcode-scanner
                      :class="!ticket_barcode ? 'full-width success' : 'full-width error'"
                      barcodeId="ticket_barcode"
                      barcodeAction="assembly: scan tickets"
                      v-model="ticket_barcode"
                      @change="recordBarcode($event.target.value, $event.target.getAttribute('action'))"
                      :key="barcodeScannerKey"
                  >
                  </barcode-scanner>


                </div>
                <div>
                  <div  class="assembly-serviceticket-list">
                    <h4 >Service Tickets</h4>
                    <table class="ticket-list">
                      <tbody >
                      <tr v-for="ticket in tickets_services" >
                        <td class="indicator" >
                          <span class="pr-3 indicator" v-if="currentTicket && currentTicket.serviceticket_id == ticket.serviceticket_id">
                            <font-awesome-icon
                                icon="arrow-alt-circle-right"
                                size="1x"
                                class="success"
                            >
                            </font-awesome-icon>
                          </span>
                        </td>
                        <td>
                          <a class="ticket-selector" @click="selectTicket(ticket)">
                            {{ticket.services.join(', ') || 'Unknown Service'}}
                          </a>
                        </td>
                        <td class="right slash">{{getAssembledCountForTicket(ticket)}}</td>
                        <td class="right slash">{{getRemainingCountForTicket(ticket)}}</td>
                        <td class="right">{{ticket.orderitems.length}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="assembly-serviceticket-selected " :class="counterState">
                  <h4>Items for Assembly</h4>
                  <p>You have selected {{selectedCount}} Items out of {{getTotalCount()}}.</p>
                </div>
                <FormKit
                    type="button"
                    label="Change Item Status"
                    input-class="$reset btn btn-primary full-width"
                    @click="viewItemStatus"
                    outer-class="mt-3 full-width"
                />
              </FormKit>
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix"></div>

      <!-- NEW TASK: Step 4 -> Confirm Number of parts -->
      <div class="clearfix"></div>
      <div class=" mt-3 text-left" >
        <div class="assemble-section col-12" :class="!check_parts_status ? 'disabled' : ''">4. Number of parts</div>
        <div v-if="check_parts_status" :class="!check_parts_status ? 'disabled' : ''">
          Please indicate how many parts this order is in:
          <div v-if="parts_error" class="fw-bold text-danger">{{parts_error}}</div>
          <FormKit
              type="form"
              @submit.prevent="preventSubmit"
              :actions="false"
              form-class="part-numbers-form "
          >

            <div class="col-md-9 multipart-button-container">
              <a v-for="i in 3" :key="i" :id="'select_part_'+i+''" :class="partCount==i ? 'selected' : ''" class="multipart-button " @click="selectParts(i);">
                {{ i }}
              </a>
              <a id="select_part_custom" ref="select_part_custom" :class="useCustomPart ? 'selected' : ''" class="multipart-button" @click="selectParts('custom');">Specify</a>
              <input type="text" id="select_part_custom_no" ref="select_part_custom_no" :class="useCustomPart ? '' : 'hidden'" @focusout="selectCustomParts($event.target.value);" @change="selectCustomParts($event.target.value);" :value="customCountPart" :key="inputKey">
            </div>
            <div class="col-md-3 text-left" v-if="check_assembly_status">
              <barcode-scanner
                  :class="!partcount_barcode ? 'full-width success' : 'full-width error'"
                  barcodeId="partcount_barcode"
                  barcodeAction="assembly: confirm part count"
                  v-model="partcount_barcode"
                  @change="recordBarcode($event.target.value, $event.target.getAttribute('action'))"
                  :key="barcodeScannerKey"
              >
              </barcode-scanner>

            </div>
          </FormKit>
        </div>
      </div>

      <div class="clearfix"></div>
      <!-- NEW TASK: Reprint buttons for last assembled order -->
      <div class=" mt-3  text-right" >
        <div class="assemble-section  top-border col-12" :class="!check_printing_status ? 'd-none' : ''">Last Order Assembled: {{last_order_id}}, {{lastOrder.firstname}} {{lastOrder.surname}}<br>
          <span class="blue-bag" v-if="blue_bag_msg" :class="blue_bag_class" >{{blue_bag_msg}}</span>
          <!-- show sweets notice if any -->
          <div v-if="getSweetsNotice()">
            <span  class="badge customer-welcome-card">{{ getSweetsNotice() }}</span>
          </div>
        </div>

        <div v-if="check_printing_status">
          <FormKit
              type="form"
              @submit.prevent="preventSubmit"
              :actions="false"
              form-class="assemble-form float-right"
          >

            <div class="clearfix"></div>

            <div class="clearfix"></div>
            <div>
              <FormKit
                  type="button"
                  :label="'Reprint Receipt'"
                  @click="reprintLastOrderReceipt"
                  input-class="$reset btn btn-primary btn-sm"
                  outer-class="float-left mr-4"
              />
              <FormKit
                  type="button"
                  :label="'Reprint Nametag'"
                  @click="reprintLastOrderNametag"
                  input-class="$reset btn btn-primary btn-sm"
                  outer-class="float-left mr-4"
              />
              <FormKit
                  type="button"
                  label="Change Parts Number"
                  input-class="$reset btn btn-primary btn-sm"
                  @click="showPartNumberOptions"
                  outer-class="float-left mr-4"
              />
              <FormKit
                  type="button"
                  label="View Order"
                  input-class="$reset btn btn-primary btn-sm"
                  @click="getViewLastOrderLink"
                  outer-class="float-left mr-4"
              />
              <FormKit
                  type="button"
                  label="View Item Status"
                  input-class="$reset btn btn-primary btn-sm"
                  @click="getViewLastOrderItemsLink"
                  outer-class="float-left mr-4"
              />
            </div>
          </FormKit>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" tabindex="-1" id="confirmAssembledModal" ref="confirmAssembledModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Part of the order is already assembled/on van</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="alert alert-warning" >
            Part of the order is already assembled/on van, please find the order and tie it together with this one

            <div class="mt-3">
              <div class="formkit-inner barcode-inner barcode-input" :class="'warning'">
                     <span  class="pl-1">
                       <font-awesome-icon
                           icon="barcode"
                           size="1x"
                           title="barcode"
                       >
                       </font-awesome-icon>
                     </span>
                <input
                    v-model="command_barcode_confirmation"
                    type="text"
                    id="command_barcode_confirmation"
                    class="formkit-input barcode-input "
                    v-focus
                >
                <span class="pr-1">
                      <font-awesome-icon
                          icon="search"
                          size="1x"
                          title="search"
                      >
                       </font-awesome-icon>
                    </span>
                <p class="epos-barcode-scanner-status"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="confirmPartialAssembled">Confirm</button>

          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>

        </div>
      </div>
    </div>
  </div>


  <div class="modal" tabindex="-1" id="confirmResetOrderModal" ref="confirmResetOrderModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Update parts number?</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="alert alert-warning" v-if="!order_reset_loaded" >
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <div>Update order details...</div>
          </div>

          <div v-if="!order_reset_error && order_reset_loaded">
            Are you sure you want to update order  {{ orderReset.resetOrderId }}<br/>
            from {{ orderReset.resetOrderCustomer }} <br/>due on {{formatDateDayShort(orderReset.resetOrderDueDate)}} ({{formatDateEN(orderReset.resetOrderDueDate)}})<br/>
            to {{ orderReset.resetPartNumber }} parts?
          </div>

          <div v-if="order_reset_error">
            <div class="alert alert-danger">Order {{ orderReset.resetOrderId }}<br/>{{order_reset_error}}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button  v-if="!order_reset_error && order_reset_loaded" type="button" class="btn btn-primary" @click="updateResetOrder">Update</button>

          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import {onMounted, ref, watch, inject} from 'vue'
import 'bootstrap/dist/css/bootstrap.min.css';
import BarcodeScanner from "@/components/elements/BarcodeScanner.vue";
import { formatDateDayShort, formatDateEN, formatFullDateEN, isToday } from '@/utils/dateUtils';

import VueCookies from "vue-cookies";
//import Data Services
import AssembleDataService from "@/services/AssembleDataService";
import ProductionStatusService from "@/services/ProductionStatusService";
import CustomerColoursDataService from "@/services/CustomerColoursDataService";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";

const barcodePatterns = inject('barcodePatterns');
const baseEPOSPath = process.env.VUE_APP_EPOS_API_BASE;
const servicesWithoutPiecingUp = inject('servicesWithoutPiecingUp');
const servicesExceptions = inject('servicesExceptions');
const test_environment = (inject('test_environment') === 'true');
console.log("test_environment", test_environment);

//define const for this section
const sessionUser = ref({
  id: 0,
  username: "",
  userlabel: "",
  workstation: "",
})
const aliases = ref(false);
const qrcode = ref('');
const check_qrcode = ref(false);
const qrcode_reset = ref(false);
const order_error = ref('');
const order_changed = ref(false);
const order = ref({
  orderid: 0,
  customer_id: "",
  locker_id_collect: "",
  location_id_collect: "",
  orderstatus_id:"",
  datedue:"",
  datecollect:"",
  dateexpecteddelivery:"",
  orderpaid:"",
  payable:"",
  paystatustype:"",
  invoicePay:"",
  order_parts:"",
  first_order:"",
  blue_bag:""
});
const confirmResetOrderModal = ref(null);
const confirmAssembledModal = ref(null);
const orderReset = ref({
  resetOrderCode: "",
  resetOrderId: "",
  resetPartNumber: "",
  resetOrderCustomer: "",
  resetOrderDueDate: ""
});
const order_reset_error = ref('');
const order_reset_loaded = ref(false);
const barcodeScannerKey = ref(0);
const inputKey = ref(0);

const order_states = ref([]);
const customer = ref({
  customerid: "",
  firstname: "",
  surname: "",

});
const notes_barcode = ref('');
const notes_barcode_show = ref('false');
const counterState= ref('none');
const selectedCount= ref(false);
const check_tickets_status = ref(false);
const ticket_barcode = ref('');
const tickets_services = ref('');
const tickets_services_assembling = ref('');
const currentTicket = ref(false);
const current_ticket_barcode = ref('');
const itemIDsToAssemble= ref([]);
const itemsAlreadyAssembledOrOnVan= ref([]);
const check_parts_status = ref(false);
const check_printing_status = ref('');
const printing_status = ref('');
const check_ticket_barcode = ref('');
const check_notes_error = ref('');
const notes_message = ref('');
const notes_error = ref('');
const partCount = ref('');
const partcount_barcode = ref('');
const parts_error = ref('');
const customCountPart = ref('');
const useCustomPart = ref(false);
const labelCountPart = ref('');
const lastOrder = ref([]);
const last_order_id = ref('');
const last_ticket_barcode = ref('');

const check_assembly_status = ref(false);

const confirm_assembled_seen= ref(false);
const command_barcode_confirmation = ref('');
const blue_bag_class = ref('');
const blue_bag_msg = ref('');
const show_step3_link = ref(false);

/*
 * GENERAL METHODS
 */
const forceRenderBarcodeScanner = () => {
  barcodeScannerKey.value += 1;
};
const forceRenderInput = () => {
  inputKey.value += 1;
};

const closeModal = (modalID) => {
  if (modalID == 'confirmResetOrderModal') {
    bootstrap.Modal.getInstance(confirmResetOrderModal.value)?.hide();
  }
  if (modalID == 'confirmAssembledModal') {
    bootstrap.Modal.getInstance(confirmAssembledModal.value)?.hide();
  }

}
const openModal = (modalID) => {
  if (modalID == 'confirmResetOrderModal') {
    bootstrap.Modal.getInstance(confirmResetOrderModal.value)?.show();
  }
  if (modalID == 'confirmAssembledModal') {
    bootstrap.Modal.getInstance(confirmAssembledModal.value)?.show();
  }
}


const resetFormResetOrder = () =>  {
  orderReset.value.resetOrderCode = "";
  orderReset.value.resetOrderId = "";
  orderReset.value.resetPartNumber = "";
  orderReset.value.resetOrderCustomer = "";
  orderReset.value.resetOrderDueDate = "";
  confirm_assembled_seen.value = false;
  currentTicket.value = false;

  show_step3_link.value = false;
}
const updateResetOrder = () => {
  if (orderReset.value.resetPartNumber <= 10) {
    useCustomPart.value = false;
    partCount.value = orderReset.value.resetPartNumber;
    labelCountPart.value = partCount.value ;
  }  else {
    useCustomPart.value = true;
    customCountPart.value = orderReset.value.resetPartNumber;
    labelCountPart.value = customCountPart.value ;
    partCount.value = orderReset.value.resetPartNumber;
  }

  last_order_id.value = orderReset.value.resetOrderId;
  lastOrder.value.firstname = customer.value.firstname;
  lastOrder.value.surname = customer.value.surname;
  lastOrder.value.customerid = customer.value.customerid;
  lastOrder.value.blue_bag = "";
  lastOrder.value.first_order = "";
  lastOrder.value.itemsToBeAssembled = "";

  //printing section
  check_printing_status.value=true;
  printing_status.value=true;

  AssembleDataService.setOrderNumParts(orderReset.value.resetPartNumber, orderReset.value.resetOrderId)
      .then(response => {
        //console.log(response);
      })
      .catch(e => {
        // console.log("error setItemStatusAssembled ");
        // console.log(e);
      });
  closeModal('confirmResetOrderModal');
  order_reset_loaded.value = false;

};

const getOrderItemClass = (orderItem, item) => {
  //if is Laundry (service_id: 3) or Return Only (service_id: 72) need to be green
  let isException = false;
  for (let service_id of item.service_ids) {
    if (servicesExceptions.includes(Number(service_id))) {
      isException=true;
    }
  }
  if (itemIsReady( orderItem )) {
    if (isException) {
      return 'selected';
    }
    return 'flagged';
  }
  if (itemCanBeAssembled( orderItem, item )) {
    return 'selected';
  }

  return 'disabled';
};
const getOrderItemIcon = (orderItem, item) => {
  //if is Laundry (service_id: 3) or Return Only (service_id: 72) need to be green
  let isException = false;
  for (let service_id of item.service_ids) {
    if (servicesExceptions.includes(Number(service_id))) {
      isException=true;
    }
  }
  if (itemIsReady( orderItem )) {
    if (isException) {
      return 'fas fa-check-circle';
    }
    return 'fas fa-exclamation-circle';
  }
  if (itemCanBeAssembled( orderItem, item )) {
    return 'fas fa-check-circle';
  }

  return 'fas fa-times-circle';
};

const getOrderItemStatus = (orderItem) => {
  for( let status in aliases.value ) {
    if( aliases.value[status] ==  orderItem.itemstatustype_id) {
      return status;
    }
  }
  return '';
};
const getBarcodeDetails = (barcode) => {
  let barcode_type;
  let barcode_id;
  for( let type in barcodePatterns ) {
    let matchResult = barcode.match( barcodePatterns[type] );
    if( matchResult ) {
      barcode_type  = type;
      barcode_id    = matchResult[1] || barcode;
      break;
    }
  }
  let barcode_details ={ type: barcode_type, id: barcode_id, barcode: barcode };

  return barcode_details;
};
const resetOnlyForms = () =>  {
  qrcode.value= '';
  check_qrcode.value= false;
  order_error.value= false;
  order_changed.value= false;
  qrcode_reset.value= false;
  check_notes_error.value= false;
  notes_error.value='';
  notes_message.value='';
  check_tickets_status.value= false;
  ticket_barcode.value='';
  notes_barcode.value='';
  notes_barcode_show.value= false;
  // tickets_services.value=false;
  tickets_services_assembling.value=false;
  itemIDsToAssemble.value = [];
  itemsAlreadyAssembledOrOnVan.value = [];
  counterState.value = 'none';
  selectedCount.value = 0;
  check_assembly_status.value = false;
  check_parts_status.value= false;
  check_printing_status.value= false;
  printing_status.value= false;
  //customCountPart.value='';
  parts_error.value='';
  //partCount.value='';
  confirm_assembled_seen.value = false;
  show_step3_link.value = false;
  currentTicket.value = false;
}
const resetForms = () =>  {
  qrcode.value= '';
  /*customer.value.customerid= "";
  customer.value.firstname= "";
  customer.value.surname= "";*/

  order.value.orderid= 0;
  //order.value.customer_id= "";
  order.value.locker_id_collect= "";
  order.value.location_id_collect= "";
  order.value.orderstatus_id="";
  order.value.datedue="";
  order.value.datecollect="";
  order.value.dateexpecteddelivery="";
  order.value.orderpaid="";
  order.value.payable="";
  order.value.paystatustype="";
  order.value.invoicePay="";
  order.value.order_parts="";
  order.value.first_order="";
  order.value.blue_bag="";
  order_states.value=[];

  check_qrcode.value= false;
  order_error.value= false;
  order_changed.value= false;
  qrcode_reset.value= false;
  check_notes_error.value= false;
  notes_error.value='';
  notes_message.value='';
  check_tickets_status.value= false;
  ticket_barcode.value='';
  notes_barcode.value='';
  notes_barcode_show.value= false;
  // tickets_services.value=false;
  tickets_services_assembling.value=false;
  itemIDsToAssemble.value = [];
  itemsAlreadyAssembledOrOnVan.value = [];
  counterState.value = 'none';
  selectedCount.value = 0;
  check_assembly_status.value = false;
  check_parts_status.value= false;
  check_printing_status.value= false;
  printing_status.value= false;
  //customCountPart.value='';
  parts_error.value='';
  //partCount.value='';
  confirm_assembled_seen.value = false;
  show_step3_link.value = false;
  currentTicket.value = false;
};
const resetBarcode = () =>  {
  qrcode_reset.value=true;
};
const recordBarcode = async (value, action) => {
  if (value != "")
  {
    let barcodeDetails = getBarcodeDetails(value);
    let workstation_id = VueCookies.get('epos2_workstationid');
    AssembleDataService.recordBarcodeScan(value, barcodeDetails['type'], action, workstation_id)
        .catch(error => {
          console.error('An error occurred logging the barcode', error);
        });
  }
};

const checkScannedTicket = (ticket_barcode) =>{
  let ticket_exist = false;

  tickets_services.value.forEach(function (item) {
    if (item['serviceticket_id'] == ticket_barcode)
    {
      ticket_exist = true;
    }
  });
  return ticket_exist;
};

const currentTicketService = () =>{
  let currentTicketItem = [];

  tickets_services.value.forEach(function (item) {
    if (item['barcode'] == current_ticket_barcode.value)
    {
      currentTicketItem.push(item);
    }
  });
  return currentTicketItem;
};
const setTicketServiceItemOptions = () => {
  //need to set up class and if can or not be canBeAssembled
  //selectedCount.value = currentTicket.value.orderitems.length;
  current_ticket_barcode.value = currentTicket.value.barcode;
  currentTicketItems();
  selectedCount.value =itemIDsToAssemble.value.length;
  updateSelectedCount();

  if (itemsAlreadyAssembledOrOnVan.value.length > 0 ) {
    confirm_assembled_seen.value = true;
  }
  //if (last_order_id.value == "") {
    last_order_id.value = order.value.orderid;
    lastOrder.value.id = order.value.orderid;
    lastOrder.value.customerid = order.value.customer_id;

    lastOrder.value.firstname = customer.value.firstname;
    lastOrder.value.surname = customer.value.surname;
    lastOrder.value.blue_bag = order.value.blue_bag;
    lastOrder.value.first_order = order.value.first_order;
  //}
  

}
const checkAssembledOrOnVan  = () =>{
  tickets_services.value.forEach(function (item) {
    item['orderitems'].forEach(function (orderitem) {
      if (itemAlreadyAssembledOrOnVan( orderitem, item )) {
        itemsAlreadyAssembledOrOnVan.value.push(orderitem['orderitemid']);
      }
    });
  });
};
const currentTicketItems = () =>{
  tickets_services.value.forEach(function (item) {
    if (item['barcode'] == current_ticket_barcode.value)
    {
      if (requiresAssemblyChecks(item['service_ids'])) {
        item['orderitems'].forEach(function (orderitem) {
          //check if item can be assebled
          if (itemCanBeAssembled( orderitem, item )) {
            itemIDsToAssemble.value.push(orderitem['orderitemid']);
          }
        });
      }
    }
  });

  let uniqueAssembleItems = [...new Set(itemIDsToAssemble.value)];
  itemIDsToAssemble.value=uniqueAssembleItems;

  return itemIDsToAssemble.value;
};
const getTotalCount = () => {
  if( ! tickets_services.value.length )
    return 0;

  return tickets_services.value.reduce( (total, ticket) => {
    return total + ticket.orderitems.length;
  }, 0 );
};
const getSelectedCount = () => {
  let count;
  if( ! currentTicket.value.length ) {
    count = 0;
  } else {
    count =  currentTicket.value.reduce( (total, ticket) => {
      return total + ticket.orderitems.length;
    }, 0 );
  }
  selectedCount.value = count;
  updateSelectedCount();
};
const updateSelectedCount = () =>{
  let count = itemIDsToAssemble.value.length;

  if( count == 0 ) {
    counterState.value = 'none';
  } else if( count < getTotalCount() ) {
    counterState.value = 'some';
  } else {
    counterState.value = 'all';
  }
};

const getBlueBagNoticeClass = () => {
  if( ! order.value.orderid )
    return '';
  if( order.value.first_order )
    return 'first-order';
  if( ! order.value.blue_bag ||  order.value.blue_bag  == 0)
    return 'no-bag';
  return '';
};
const getBlueBagNotice = () =>{
  if( ! order.value.orderid )
    return null;
  if( order.value.first_order )
    return 'Customer is placing their first order, use a new blue bag.';
  if( ! order.value.blue_bag ||  order.value.blue_bag  == 0)
    return 'Customer did NOT use a Blue Bag.';
  return null;
};
const b2cCustomer = () =>{
  if( ! order.value.orderid )
    return null;
   //check if invoicePay is 0, priceband is standard and accountcode is empty
 if(order.value.first_order && order.value.invoicePay==0 && customer.value.priceband=='standard' && 
    (customer.value.accountcode=="" || customer.value.accountcode==null) )
    return true;
    
  return null;
};
const getSweetsNotice = () =>{
  if( ! order.value.orderid )
    return null;
  
    console.log("b2cCustomer: ", b2cCustomer());
  if( b2cCustomer() )
    return 'Please add the sweets and the welcome card for customer.';

  return null;
};
const preventSubmit = (e) => {
  e.preventDefault();
  return false;
};
const isDueUnpaid = () =>{
  console.log("payable: ", order.value.payable);
  console.log("orderid: ", order.value.orderid);
  console.log("invoicePay: ", order.value.invoicePay);
  console.log("paystatustype: ", order.value.paystatustype);
  if( ! order.value.orderid )
    return null;
  if( order.value.payable > 0 && order.value.invoicePay == 0 && order.value.paystatustype != 'Pending')
  {
    //return true;
    //check to see if due date of the order, after 9:30 AM
    if (isToday(new Date(order.value.datedue))) {
      //check if is after 9.30 am
      const now = new Date();
      let hours = now.getHours();
      let minutes = now.getMinutes();
      if ((hours == 9 && minutes > 30) || (hours > 9)) {
        return true;
      }
    }


  }

  return null;
};

/*
 * TASK ONE: Identify the Order
 */
watch(qrcode, async (newValue) => {
  if (newValue.length > 1) {
    scanQrcode(newValue);
  }
})
const  scanQrcode = async(qrcodeValue) => {
  let barcodeDetails = getBarcodeDetails(qrcodeValue);

  //reset top form for reset order
  resetFormResetOrder();
  resetForms();
  if (barcodeDetails.type == "ticket" || barcodeDetails.type == "ticket_order") {

    AssembleDataService.getOrderByServiceTicket(qrcodeValue)
        .then(response => {

          check_qrcode.value = true;
          if (response.data.result === true) {
            getSelectedCount();

            let data_customer = response.data.data.customer;
            let data_order = response.data.data.order;
            let data_order_payment = response.data.data.order_payment;
            let data_order_status = response.data.data.order_status;
            order_error.value = false;
            order_states.value=response.data.data.states;

            tickets_services.value = response.data.data.tickets;
            if (barcodeDetails.type == "ticket") {
              current_ticket_barcode.value = qrcodeValue;
            }
            checkAssembledOrOnVan();

            customer.value.customerid = data_customer.customerid;
            customer.value.firstname = data_customer.firstname;
            customer.value.surname = data_customer.surname;
            customer.value.priceband = data_customer.priceband;
            customer.value.accountcode = data_customer.accountcode;

            order.value.customer_id = data_order.customer_id;
            order.value.firstname = data_customer.firstname;
            order.value.surname = data_customer.surname;
            order.value.orderid = data_order.orderid;
            order.value.locker_id_collect = data_order.locker_id_collect;
            order.value.order_parts = data_order.order_parts;
            order.value.orderstatus_id = data_order.orderstatus_id;
            order.value.location_id_collect = data_order.location_id_collect;

            order.value.datedue = data_order.datedue;
            order.value.datecollect = data_order.datecollect;
            order.value.dateexpecteddelivery = data_order.dateexpecteddelivery;
            order.value.orderpaid = data_order.orderpaid;
            order.value.payable = data_order_payment.payable;
            order.value.paystatustype = data_order_status.paystatustype;
            order.value.invoicePay = data_order.invoicePay;

            order.value.first_order = data_order.first_order;
            order.value.blue_bag = data_order.hasBlueBag;
            order_changed.value=true;

            forceRenderInput();
            selectParts(1);
            customCountPart.value = " ";
            useCustomPart.value = false;
            partcount_barcode.value = false;

            //get notes details
            check_notes_error.value = true;
            notes_message.value = "";
            AssembleDataService.getOrderNotes(order.value.orderid, 'assembly')
                .then(response => {
                  let show_assembly_step = true;
                  if (response.data.result === true) {

                    if (response.data.data.notes.length === 0) {
                      //notes_message.value = 'No notes for review';
                      notes_message.value = false;
                      notes_error.value = 'No notes for review';
                      check_notes_error.value = true;
                    }
                    else {
                      notes_message.value = response.data.data.notes;
                      show_assembly_step = false;
                      notes_barcode_show.value = true;
                    }

                  }
                  else {
                    notes_error.value = response.data.status;
                  }

                  if (show_assembly_step === true) {
                    //activate assembly section
                    check_tickets_status.value = true;

                    //printing section
                    check_printing_status.value=false;
                    printing_status.value=false;

                    selectedCount.value = 0;
                    counterState.value = 'none';

                    check_ticket_barcode.value = true;
                  }
                })
                .catch(e => {
                  notes_error.value = e;
                  console.log(e);

                  //activate assembly section
                  check_tickets_status.value = true;

                  //printing section
                  check_printing_status.value=false;
                  printing_status.value=false;

                  selectedCount.value = 0;
                  counterState.value = 'none';

                  check_ticket_barcode.value = true;
                });
          }
          else {
            resetForms();
            //order_error.value = response.data.status;
            forceRenderBarcodeScanner();
            return false;
          }

        })
        .catch(e => {
          resetForms();
          order_error.value = "Order is not available anymore";
          forceRenderBarcodeScanner();
          console.log(e);
          return false;
        });
  }
  if (barcodeDetails.type == "command") {
    order_error.value="Invalid code";
    setTimeout(() => {
      order_error.value = '';
      forceRenderBarcodeScanner();
    }, 1000);
    return false;
  }


  return false;

};
const confirmOrder = async() => {
  qrcode_reset.value=false;
};
const viewOrder = () =>  {
  window.open(
      process.env.VUE_APP_EPOS_API_BASE+"/index.php?page=order&mode=process&order_id="+order.value.orderid,
      "_blank"
  );
};
const clearOrder = async() => {
  qrcode_reset.value=false;
  check_qrcode.value=false;
  qrcode.value="";
  order_changed.value = false;
  notes_error.value='';
  notes_message.value='';
  notes_barcode.value='';
  notes_barcode_show.value = false;
  check_printing_status.value = false;
  check_tickets_status.value = false;
  current_ticket_barcode.value = "";
  currentTicket.value = false;
  selectedCount.value = 0;
  itemIDsToAssemble.value = [];
  check_assembly_status.value = false;
  check_parts_status.value = false;
  show_step3_link.value = false;
};

/*
   * TASK TWO: Scan if are any assembly notes
   */
watch(notes_barcode, async (newValue) => {
  if (newValue.length > 1) {
    scanNotesQrcode(newValue);
  }
})
const scanNotesQrcode = async(notes_barcode_element) => {

  let barcodeDetails = getBarcodeDetails(notes_barcode_element);
  if (barcodeDetails.type == "command" && barcodeDetails.id == "OK") {
    //activate assembly section
    check_tickets_status.value = true;

    //printing section
    check_printing_status.value=false;
    printing_status.value=false;

    selectedCount.value = 0;
    counterState.value = 'none';

    check_ticket_barcode.value = true;
    notes_barcode_show.value = false;
  }
  else if (barcodeDetails.type == "ticket") {
    notes_barcode.value = "";
    forceRenderBarcodeScanner();
    return false;
  }
}
/*
   * TASK THREE: Scan in the service tickets
   */
watch(ticket_barcode, async (newValue) => {
  if (newValue.length > 1) {
    scanTicketQrcode(newValue);
  }
})

watch(command_barcode_confirmation, async (newValue) => {
  if (newValue.length > 1) {
    confirmPartialAssembled(newValue);
  }
})
const confirmPartialAssembled = (qrcodeValue) =>  {

  let barcodeDetails = getBarcodeDetails(qrcodeValue);

  if (barcodeDetails.type == "command" && barcodeDetails.id == "OK") {
    confirm_assembled_seen.value = false;
    command_barcode_confirmation.value = "";
    closeModal('confirmAssembledModal');
    scanTicketQrcode(qrcodeValue);
  }
};

const returnToStep3 = async() =>  {
  //disable step 4 - parts number and show step 3
  check_tickets_status.value = true;
  partCount.value = 1;
  check_parts_status.value = false;
  check_assembly_status.value = false;
  if (itemsAlreadyAssembledOrOnVan.value.length > 0 ) {
    confirm_assembled_seen.value = true;
  }
  show_step3_link.value = false;
  ticket_barcode.value="";

};
const scanTicketQrcode = async(ticket_barcode_element) => {


  let barcodeDetails = getBarcodeDetails(ticket_barcode_element);

  let barcodeTicket = 0;
  if (barcodeDetails.type == "ticket") {
    current_ticket_barcode.value = ticket_barcode_element;
    last_ticket_barcode.value = ticket_barcode_element;
    last_order_id.value = order.value.orderid;

    barcodeTicket = parseInt(barcodeDetails.id);
  }

  if (barcodeDetails.type == "command" && barcodeDetails.id == "OK") {
    if ( selectedCount.value == 0) {
      ticket_barcode.value = "";
      counterState.value = 'none';
      alert("No items to be assembled");
      forceRenderBarcodeScanner();
      return false;
    }

    if (confirm_assembled_seen.value == true) {
      ticket_barcode.value = "";

      openModal('confirmAssembledModal');
      let command_barcode_confirmation_ref = document.getElementById("command_barcode_confirmation");
      if (command_barcode_confirmation_ref) {
        command_barcode_confirmation_ref.focus();
      }
      return false;
    }
    //marked items and show number of parts
    check_tickets_status.value = false;
    partCount.value = 1;
    check_parts_status.value = true;
    check_assembly_status.value = true;
    show_step3_link.value = true;
    forceRenderBarcodeScanner();

  } else if (barcodeDetails.type == "ticket") {
    currentTicket.value = currentTicketService(barcodeTicket)[0];
    ticket_barcode.value = "";
    currentTicketItems();

    if (itemsAlreadyAssembledOrOnVan.value.length > 0 ) {
      confirm_assembled_seen.value = true;
    }

    order_error.value = false;
    lastOrder.value = order.value;
    check_ticket_barcode.value = true;
    selectedCount.value = itemIDsToAssemble.value.length;
    updateSelectedCount();
    show_step3_link.value = false;
    forceRenderBarcodeScanner();
    //console.log(barcodeTicket);
    //check if ticket scanned if from other order
    let order_ticket = checkScannedTicket(barcodeTicket);
    if (!order_ticket) {
      alert("This ticket does not belong to the order being assembled. Please check.");
    }
    //console.log(order_ticket);

  }
  return false;

};
const selectTicket = ( ticket ) => {
  currentTicket.value = ticket;
  setTicketServiceItemOptions();
};
const getAssembledCountForTicket = ( ticket ) => {
  if( !ticket.orderitems.length )
    return 0;

  return ticket.orderitems.reduce(
      // (total, item) => total + ( selectionStates[item.orderitem_id] === true ? 1 : 0 ), 0
      (total, item) => total + ( itemCanBeAssembled(item, ticket) ? 1 : 0 ), 0
  );
};
const requiresAssemblyChecks = (service_ids) => {
  for (let service_id of service_ids) {
    if (servicesWithoutPiecingUp.includes(service_id))
      return false
  }
  return true
};
const itemIsReady = ( orderitem ) => {
  if( !aliases.value )
    return false;

  return ProductionStatusService.equalTo( aliases.value.processed,  orderitem.itemstatustype_id )
      || ProductionStatusService.equalTo( aliases.value.atSupplier,  orderitem.itemstatustype_id )
      || ProductionStatusService.equalTo( aliases.value.backFromSupplier,  orderitem.itemstatustype_id );

};
const itemCanBeAssembled = ( orderitem, serviceticket ) => {
  if( !aliases.value )
    return false;

  if( !requiresAssemblyChecks(serviceticket.service_ids.map(id => parseInt(id))) )
    return ! ProductionStatusService.afterOrEqualTo( aliases.value.assembled, orderitem.itemstatustype_id );

  return ProductionStatusService.afterOrEqualTo( aliases.value.piecedUp,  orderitem.itemstatustype_id )
      && ! ProductionStatusService.afterOrEqualTo( aliases.value.assembled, orderitem.itemstatustype_id );

};
const itemAlreadyAssembledOrOnVan = ( orderitem, serviceticket ) => {
  if( !aliases.value )
    return false;

  return ProductionStatusService.equalTo( aliases.value.assembled, orderitem.itemstatustype_id ) ||
      ProductionStatusService.equalTo( aliases.value.onVan, orderitem.itemstatustype_id );

};
const getRemainingCountForTicket = ( ticket ) => {
  if( !ticket.orderitems.length )
    return 0;

  return ticket.orderitems.reduce(
      (total, item) => total + ( itemCanBeAssembled(item, ticket) ? 1 : 0 ), 0
  ) - getAssembledCountForTicket(ticket);
};
const viewItemStatus = async() =>  {
  window.open(
      process.env.VUE_APP_EPOS_API_BASE+"/index.php?page=order&mode=assemble&orderid="+order.value.orderid,
      "_blank"
  );
};


/*
   * TASK FOUR: Number of parts
   */
watch(partcount_barcode, async (newValue) => {
  if (newValue.length > 1) {
    onPartCountScan(newValue);
  }
});


const getPartCount = () => {
  labelCountPart.value = useCustomPart.value ? customCountPart.value : partCount.value ;
  return useCustomPart.value ? customCountPart.value : partCount.value ;
};
const selectParts = (part_no) => {
  useCustomPart.value = false;
  customCountPart.value = ' ';
  partCount.value = part_no;
  if (part_no == 'custom') {
    useCustomPart.value = true;
    customCountPart.value = '';
  }
  else {
    labelCountPart.value = part_no;
    let partcount_barcode_ref = document.getElementById("partcount_barcode");
    if (partcount_barcode_ref) {
      partcount_barcode_ref.focus();
    }
  }
};
const selectCustomParts = (part_no) => {
  partCount.value = ' ';
  useCustomPart.value = true;
  customCountPart.value = part_no;
  labelCountPart.value = part_no;

  let partcount_barcode_ref = document.getElementById("partcount_barcode");
  if (partcount_barcode_ref) {
    partcount_barcode_ref.focus();
  }
};

const onPartCountScan = async() => {
  if (partcount_barcode.value == ''){
    forceRenderBarcodeScanner();
    return false;
  }

  let count_parts = getPartCount();

  let barcodeDetails = getBarcodeDetails(partcount_barcode.value);
  if (barcodeDetails.type == "command" && barcodeDetails.id == "OK") {
    //print label ticket ; reset the form and show print buttons
    if (count_parts == '' )
    {
      //should alert
      parts_error.value = "Please select the parts number!";
      partcount_barcode.value = "";
      return false;
    }

    //check user id
    let epos_userid = VueCookies.get('epos2_userid');

    if (sessionUser.value.id != "") {
      epos_userid = sessionUser.value.id;
    }

    //in case update/change the part numbers and print again
    if (order.value.orderid == 0) {
      order.value.orderid = last_order_id.value;
      order.value.blue_bag = lastOrder.value.blue_bag;
      order.value.first_order = lastOrder.value.first_order;
    }

    //colect last order blue bag details
    blue_bag_class.value = getBlueBagNoticeClass();
    blue_bag_msg.value = getBlueBagNotice();
    if (blue_bag_class.value == 'no-bag') {
      blue_bag_class.value = '';
      blue_bag_msg.value = '';
    }
    let needPrintNametag = 1;
    let itemsToBeAssembled = itemIDsToAssemble.value.join(',');
    if (itemsToBeAssembled != "") {
      lastOrder.value.itemsToBeAssembled = itemsToBeAssembled;
    }
    else if (lastOrder.value.itemsToBeAssembled != "") {
      itemsToBeAssembled = lastOrder.value.itemsToBeAssembled;
      //means the parts were changed
      needPrintNametag = 0;
    }

    console.log("l.1440: test_environment ", test_environment);
    console.log('Need to Printing: '+order.value.orderid + ' - parts: ' + count_parts + ' - items: ' +itemsToBeAssembled);
    console.log('Print NameTAG: ', needPrintNametag);
    if (test_environment) {
      console.log('Printing: '+order.value.orderid + ' - parts: ' + count_parts + ' - items: ' +itemsToBeAssembled);
      //resetForms();
      resetOnlyForms();
      check_printing_status.value=true;
      return false;
    }

    await AssembleDataService.setItemStatusAssembledAndPrintTag(itemsToBeAssembled, needPrintNametag, true, count_parts)
        .then(response => {
          //console.log(response);
          //resetForms();
          resetOnlyForms();
          partcount_barcode.value = "";
          forceRenderBarcodeScanner();
          check_printing_status.value=true;
        })
        .catch(e => {
          console.log("error setItemStatusAssembled ");
          console.log(e);
        });
    printing_status.value=true;

    return false;
  }
  else if (barcodeDetails.type == "ticket") {
    forceRenderBarcodeScanner();
  }
};

/*
 * TASK FIVE: Printing area
 */
const reprintLastOrderReceipt = async() => {
  if (last_order_id.value == ''){
    return false;
  }
  let count_parts = getPartCount();
  let workstation_id = VueCookies.get('epos2_workstationid');
  if (test_environment) {
    console.log('Printing LastOrderReceipt: order: '+ last_order_id.value +' - parts: '+ count_parts +' - ws: '+ workstation_id);
    return false;
  }
  AssembleDataService.reprintLastOrderReceipt( last_order_id.value, count_parts)
      .then(response => {
        //console.log('Printing: '+ last_order_id.value +' - '+ count_parts +' - '+ workstation_id);
        //console.log(response);
      })
      .catch(e => {

        //console.log(e);
      });
};
const reprintLastOrderNametag = async() => {
  if (last_order_id.value == ''){
    return false;
  }
  console.log('Printing printCustomerTag: order: '+ last_order_id.value +' - customer: '+ lastOrder.value.customerid +' - cid: '+ order.value.customer_id);
  if (test_environment) {
    //console.log('Printing printCustomerTag: '+ last_order_id.value +' - '+ lastOrder.value.customerid);
    return false;
  }

  await AssembleDataService.printCustomerTag(  order.value.customer_id)
      .then(response => {
        //console.log('Printing: '+ last_order_id.value +' - '+ count_parts +' - '+ workstation_id);
        //console.log(response);
      })
      .catch(e => {

        //console.log(e);
      });
};

const showPartNumberOptions = () => {
  partcount_barcode.value = '';
  check_assembly_status.value = true;
  check_parts_status.value = true;
};
const getViewLastOrderLink = () => {
  if (last_order_id.value == ''){
    return false;
  }
  window.open(
      process.env.VUE_APP_EPOS_API_BASE+"/index.php?page=order&mode=process&order_id="+last_order_id.value,
      "_blank"
  );
};
const getViewLastOrderItemsLink = () => {
  if (last_order_id.value == ''){
    return false;
  }
  window.open(
      process.env.VUE_APP_EPOS_API_BASE+"/index.php?page=order&mode=assemble&orderid="+last_order_id.value,
      "_blank"
  );
};



onMounted(() => {
  confirmResetOrderModal.value = new bootstrap.Modal('#confirmResetOrderModal', {})
  confirmAssembledModal.value = new bootstrap.Modal('#confirmAssembledModal', {})

  ProductionStatusService.loaded.then( () => {
    aliases.value = ProductionStatusService.getAliases();
  });

  const serializedObject = localStorage.getItem("sessionDetails");
  if (serializedObject) {
    sessionUser.value = JSON.parse(serializedObject)
  }
})
</script>

<style scoped>
.btn-notes {
  background-color: #E6E6FA;
  border-color: #E6E6FA;
  color: #000;
}
.disabled {
  color: var(--disabled-color)!important;
}
.hidden {
  display: none;
}
.full-width {
  width: 100%;
}
.update-part-number {
  width: 90%;
  margin: 10px auto;
  padding: 10px 20px;
  border: 1px solid var(--form-border-color);
  box-shadow: 0 2px 3px var(--form-shadow-color);
  display: grid;
}
.assemble-sections {
  width: 90%;
  margin: 30px auto;
  padding: 20px;
  border: 1px solid var(--form-border-color);
  box-shadow: 0 2px 3px var(--form-shadow-color);
  display: grid;
}

.assemble-section {
  border-bottom: 1px solid var(--form-border-color);
  padding-bottom: 5px;
  display: block;
  font-weight: bold;
}
.assemble-section.top-border {
  border-top: 1px solid var(--form-border-color);
  border-bottom: none;
  padding-top: 5px;
}
.part-numbers-form {
  display: flex;
}
.large-text {
  font-size: 1.3rem;
}
small {
  margin-bottom: 10px;
  padding-top: 5px;
  display: block;
}
.formkit-input.barcode-input{
  width: 80%;
  display: inline-block;
  background-color: transparent;
}
.epos-barcode-scanner-status {
  font-weight: bold;
}
.barcode-inner {
  border-radius: 10px;
  display: block;
  font-size: 12px;
}

.barcode-input {
  width: 50%;
  background-color: #fff;
}
.barcode-input.full-width {
  width: 100%;
}
.barcode-input.success {
  background-color: var( --light-green-color);
}
.barcode-input.error {
  background-color: var( --light-red-color);
}
.input {
  margin: 10px auto;
}
.customer-state {
  background-color: var( --success-color)!important;
}
.customer-state.handling {
  background-color: var(--handling-color)!important;
}
.customer-welcome-card {
  background-color: var( --rewarding-color)!important;
}
.due-unpaid {
  background-color: var( --light-red-color);
  padding: 10px;
  margin: 0;
  font-size: 14px;
  font-weight: bold;
  box-sizing: border-box;
  border-radius: 3px;
  border: 1px solid #2b647b;
  color: #2c3e50;
}
.input label {
  display: block;
  color: #4e4e4e;
  margin-bottom: 6px;
}

.input input {
  font: inherit;
  width: 100%;
  padding: 6px 12px;
  border-radius: 7px;
  box-sizing: border-box;
  border: 1px solid #ccc;
}

.input input:focus {
  outline: none;
  border: 1px solid #521751;
  background-color: #eee;
}

.submit button {
  border: 1px solid #521751;
  color: #521751;
  padding: 10px 20px;
  font: inherit;
  cursor: pointer;
  border-radius: 18px;
}

.submit button:hover,
.submit button:active {
  background-color: #521751;
  color: white;
}

.submit button[disabled],
.submit button[disabled]:hover,
.submit button[disabled]:active {
  border: 1px solid #ccc;
  background-color: transparent;
  color: #ccc;
  cursor: not-allowed;
}


#assemblyWidget .order-id .large {
  font-weight: 700
}

#assemblyWidget .order-id .small {
  color: #666
}

#assemblyWidget div.order-confirm,#assemblyWidget div.order-confirm p {
  font-size: 22px;
  margin-bottom: 0
}

#assemblyWidget div.order-confirm span.datedue {
  color: #666;
  font-size: 16px;
  display: block;
  margin: 5px 0
}

#assemblyWidget div.order-confirm span.datedue span.blue-bag, span.blue-bag {
  font-weight: 700
}

#assemblyWidget div.order-confirm span.datedue span.blue-bag.no-bag, span.blue-bag.no-bag {
  color: red
}

#assemblyWidget div.order-confirm span.datedue span.blue-bag.first-order , span.blue-bag.first-order {
  color: green
}

#assemblyWidget div.assembly-serviceticket-list,#assemblyWidget div.assembly-serviceticket-selected {
  box-sizing: border-box;
  border-radius: 3px;
  border: 1px solid #2b647b;
  width: 100%;
  margin-top: 10px
}

#assemblyWidget div.assembly-serviceticket-list h4,#assemblyWidget div.assembly-serviceticket-selected h4 {
  background: #2b647b;
  color: #fff;
  margin: 0;
  padding: 5px;
  font-weight: 700;
  font-size: 14px
}

#assemblyWidget div.assembly-serviceticket-selected.none {
  background: #ffb6c1
}

#assemblyWidget div.assembly-serviceticket-selected.some {
  background: #fafad2
}

#assemblyWidget div.assembly-serviceticket-selected.all {
  background: #90ee90
}

#assemblyWidget div.assembly-serviceticket-selected p {
  padding: 10px;
  margin: 0;
  font-size: 14px;
  font-weight: bold;
}

#assemblyWidget div.assembly-serviceticket-list p {
  font-size: 12px;
  padding: 10px 5px
}

#assemblyWidget div.assembly-serviceticket-list .ticket-list {
  width: 100%
}

#assemblyWidget div.assembly-serviceticket-list .ticket-list td,#assemblyWidget div.assembly-serviceticket-list .ticket-list th {
  font-size: 12px;
  vertical-align: top
}

#assemblyWidget div.assembly-serviceticket-list .ticket-list td.indicator {
  width: 17px
}

#assemblyWidget div.assembly-serviceticket-list .ticket-list span.indicator {
  color: #2b647b
}

#assemblyWidget div.assembly-serviceticket-list .ticket-list td.right {
  text-align: right
}

#assemblyWidget div.assembly-serviceticket-list .ticket-list td.slash::after {
  content: '/';
  margin-left: 5px;
  color: #888
}

#assemblyWidget div.assembly-serviceticket {
  border: 1px solid #2b647b;
  margin-right: 300px;
  margin-bottom: 10px;
  border-radius: 3px;
  font-size: 12px;
  width: 100%;
}

#assemblyWidget div.assembly-serviceticket h4 {
  margin: 0;
  padding: 5px;
  background: #2b647b;
  color: #fff;
  border-radius: 2px 2px 0 0
}

#assemblyWidget div.assembly-serviceticket .assembly-serviceticket-services {
  background: #ace1fa;
  margin: 0;
  padding: 4px 5px
}

#assemblyWidget div.assembly-serviceticket .assembly-serviceticket-services span {
  float: right
}

#assemblyWidget div.assembly-serviceticket p {
  padding: 4px 5px;
  margin: 0
}

#assemblyWidget div.assembly-serviceticket p.scanTicket {
  font-style: italic;
  color: #666
}

#assemblyWidget div.assembly-serviceticket td,#assemblyWidget div.assembly-serviceticket th {
  font-size: 12px;
  padding: 2px 10px
}

#assemblyWidget div.assembly-serviceticket .assembly-serviceticket-items {
  border-collapse: collapse;
  width: 100%;
}

#assemblyWidget div.assembly-serviceticket .assembly-serviceticket-items tr.header {
  border-bottom: 1px solid #2b647b
}

#assemblyWidget div.assembly-serviceticket .assembly-serviceticket-items tr.header th {
  padding-top: 5px;
  padding-bottom: 5px
}

#assemblyWidget div.assembly-serviceticket .assembly-serviceticket-items tr.header+tr td {
  padding-top: 5px
}

#assemblyWidget div.assembly-serviceticket .assembly-serviceticket-items tr.selected {
  background-color: #90ee90
}

#assemblyWidget div.assembly-serviceticket .assembly-serviceticket-items tr.disabled {
  background-color: #ffffe0
}

#assemblyWidget div.assembly-serviceticket .assembly-serviceticket-items tr.flagged {
  background-color: #ffb6c1
}


.multipart-button {
  background: #d3d3d3;
  color: #a9a9a9;
  display: inline-block;
  line-height: 25px;
  min-width: 30px;
  text-align: center;
  padding: 15px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 3px
}

.multipart-button.selected {
  background: #2b647b;
  color: #fff
}

.multipart-button.end {
  margin-right: 0
}
</style>
